import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Teaser";

const PassPage = lazy(() => import("@/pages/PassPage"));
const Admin = lazy(() => import("@/pages/Admin"));
const Legal = lazy(() => import("@/pages/Legal"));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div className="min-h-screen bg-[#101C18]" />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pass/:number" element={<PassPage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<Legal kind="privacy" />} />
          <Route path="/terms" element={<Legal kind="terms" />} />
        </Routes>
      </Suspense>
      <Toaster position="bottom-center" toastOptions={{ style: { background: "#FFF7F0", color: "#101C18", fontFamily: "Lora, serif" } }} />
    </BrowserRouter>
  );
}

export default App;
